import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "golf-promo-codes-page" }
const _hoisted_2 = { class: "top-controls" }
const _hoisted_3 = { class: "page-title-section" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "page-subtitle" }
const _hoisted_6 = { class: "top-actions" }
const _hoisted_7 = { class: "roles-header-cards promo-stats-cards" }
const _hoisted_8 = { class: "role-card stat-card-orange" }
const _hoisted_9 = { class: "role-card-inner" }
const _hoisted_10 = { class: "stat-meta" }
const _hoisted_11 = { class: "stat-card-title" }
const _hoisted_12 = { class: "stat-card-desc" }
const _hoisted_13 = { class: "stat-card-val text-orange" }
const _hoisted_14 = { class: "role-card stat-card-green" }
const _hoisted_15 = { class: "role-card-inner" }
const _hoisted_16 = { class: "stat-meta" }
const _hoisted_17 = { class: "stat-card-title" }
const _hoisted_18 = { class: "stat-card-desc" }
const _hoisted_19 = { class: "stat-card-val text-green" }
const _hoisted_20 = { class: "role-card stat-card-blue" }
const _hoisted_21 = { class: "role-card-inner" }
const _hoisted_22 = { class: "stat-meta" }
const _hoisted_23 = { class: "stat-card-title" }
const _hoisted_24 = { class: "stat-card-desc" }
const _hoisted_25 = { class: "stat-card-val text-blue" }
const _hoisted_26 = { class: "role-card stat-card-purple" }
const _hoisted_27 = { class: "role-card-inner" }
const _hoisted_28 = { class: "stat-meta" }
const _hoisted_29 = { class: "stat-card-title" }
const _hoisted_30 = { class: "stat-card-desc" }
const _hoisted_31 = { class: "stat-card-val text-purple" }
const _hoisted_32 = { class: "catalog-card" }
const _hoisted_33 = { class: "section-header" }
const _hoisted_34 = { class: "stats-row" }
const _hoisted_35 = { class: "stat-item" }
const _hoisted_36 = { class: "stat-value" }
const _hoisted_37 = { class: "stat-item" }
const _hoisted_38 = { class: "stat-value" }
const _hoisted_39 = { class: "filter-controls" }
const _hoisted_40 = { class: "search-input-wrapper" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "table-container" }
const _hoisted_43 = { class: "code-cell" }
const _hoisted_44 = { class: "code-row" }
const _hoisted_45 = { class: "code-badge" }
const _hoisted_46 = ["onClick", "title"]
const _hoisted_47 = {
  key: 0,
  class: "campaign-name"
}
const _hoisted_48 = { class: "discount-cell" }
const _hoisted_49 = { class: "discount-val" }
const _hoisted_50 = {
  key: 0,
  class: "discount-sub"
}
const _hoisted_51 = { class: "usages-cell" }
const _hoisted_52 = { class: "usages-count" }
const _hoisted_53 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_54 = {
  key: 1,
  class: "budget-sub"
}
const _hoisted_55 = { class: "conditions-cell" }
const _hoisted_56 = {
  key: 0,
  class: "condition-item"
}
const _hoisted_57 = {
  key: 1,
  class: "condition-tag"
}
const _hoisted_58 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_59 = { class: "validity-cell" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_62 = { class: "actions-cell" }
const _hoisted_63 = ["onClick", "title"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "dialog-body-form" }
const _hoisted_68 = { class: "dialog-field" }
const _hoisted_69 = { class: "dialog-field" }
const _hoisted_70 = { class: "code-input-row" }
const _hoisted_71 = { class: "dialog-hint" }
const _hoisted_72 = { class: "dialog-row-2" }
const _hoisted_73 = { class: "dialog-field" }
const _hoisted_74 = { class: "dialog-field" }
const _hoisted_75 = { class: "dialog-row-2" }
const _hoisted_76 = {
  key: 0,
  class: "dialog-field"
}
const _hoisted_77 = { class: "dialog-field" }
const _hoisted_78 = { class: "dialog-row-2" }
const _hoisted_79 = { class: "dialog-field" }
const _hoisted_80 = { class: "dialog-field" }
const _hoisted_81 = { class: "dialog-field" }
const _hoisted_82 = { class: "checkbox-row" }
const _hoisted_83 = { class: "dialog-field" }
const _hoisted_84 = { class: "date-picker-row" }
const _hoisted_85 = { class: "dialog-field" }
const _hoisted_86 = { class: "dialog-field" }
const _hoisted_87 = { class: "dialog-footer" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = { class: "dialog-body-form" }
const _hoisted_90 = { class: "dialog-row-2" }
const _hoisted_91 = { class: "dialog-field" }
const _hoisted_92 = { class: "dialog-field" }
const _hoisted_93 = { class: "dialog-field" }
const _hoisted_94 = { class: "dialog-row-2" }
const _hoisted_95 = { class: "dialog-field" }
const _hoisted_96 = { class: "dialog-field" }
const _hoisted_97 = { class: "dialog-field" }
const _hoisted_98 = { class: "date-picker-row" }
const _hoisted_99 = { class: "dialog-footer" }
const _hoisted_100 = ["disabled"]

import { ref, reactive, onMounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'
import { useGolfStore } from '@/store/golf'
import { useGolfHeaderStore } from '@/store/golf-header'
import type {
  GolfPromoCode,
  CreateGolfPromoCodePayload,
  UpdateGolfPromoCodePayload,
  BulkCreateGolfPromoCodePayload,
  PromoCodeStats,
} from '@/api/golf'

// ============ STORES ============
type PromoFormState = {
  id?: string
  code: string
  campaign_name?: string
  type: 'percent' | 'fixed' | 'wallet_credit'
  discount_value: number
  min_amount?: number
  max_discount?: number
  usage_limit?: number
  budget?: number
  new_users_only: boolean
  valid_from?: string
  valid_until?: string
  status: 'draft' | 'active' | 'paused' | 'stopped'
  allowed_modules: string[]
  applicable_tariff_ids: string[]
  description?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const vehiclesStore = useGolfVehiclesStore()
const mainGolfStore = useGolfStore()
const headerStore = useGolfHeaderStore()

// ============ TARIFFS (PROMO SELECT OPTIONS) ============
const tariffs = computed(() => vehiclesStore.profileTariffs)

// ============ PROMO CODES ENGINE STATE ============
const promoDialogVisible = ref(false)
const bulkDialogVisible = ref(false)
const promoStats = ref<PromoCodeStats | null>(null)
const promoSearch = ref('')
const promoStatusFilter = ref('')

const promoForm = reactive<PromoFormState>({
  code: '',
  campaign_name: '',
  type: 'percent',
  discount_value: 10,
  min_amount: undefined,
  max_discount: undefined,
  usage_limit: undefined,
  budget: undefined,
  new_users_only: false,
  valid_from: undefined,
  valid_until: undefined,
  status: 'active',
  allowed_modules: ['golf'],
  applicable_tariff_ids: [],
  description: '',
})

const bulkForm = reactive({
  count: 10,
  prefix: 'GOLF',
  campaign_name: '',
  type: 'percent' as 'percent' | 'fixed',
  discount_value: 10,
  max_discount: undefined as number | undefined,
  usage_limit: 1,
  valid_from: undefined as string | undefined,
  valid_until: undefined as string | undefined,
})

const formatDate = (date?: string) => {
  if (!date) return '—'
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
  ElMessage.success(`Code "${text}" copied to clipboard`)
}

const generateRandom12Code = () => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
  let result = ''
  for (let i = 0; i < 12; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  promoForm.code = result
}

const getDisplayStatus = (row: GolfPromoCode) => {
  if (row.status) return row.status
  return row.is_active ? 'active' : 'paused'
}

const getStatusBadgeClass = (row: GolfPromoCode) => {
  const status = getDisplayStatus(row)
  switch (status) {
    case 'active':
      return 'status-badge--active'
    case 'paused':
      return 'status-badge--paused'
    case 'draft':
      return 'status-badge--draft'
    case 'stopped':
    case 'expired':
      return 'status-badge--stopped'
    default:
      return 'status-badge--draft'
  }
}

// Computed stats & filters
const activeCount = computed(() => {
  return mainGolfStore.safePromoCodes.filter(
    p => getDisplayStatus(p) === 'active'
  ).length
})

const totalRedemptionsCount = computed(() => {
  return mainGolfStore.safePromoCodes.reduce(
    (acc, cur) => acc + (cur.used_count || 0),
    0
  )
})

const totalSpentAmount = computed(() => {
  return mainGolfStore.safePromoCodes.reduce(
    (acc, cur) => acc + (Number(cur.spent_budget) || 0),
    0
  )
})

const filteredPromoCodes = computed(() => {
  let list = mainGolfStore.safePromoCodes
  if (promoStatusFilter.value) {
    list = list.filter(p => getDisplayStatus(p) === promoStatusFilter.value)
  }
  if (promoSearch.value.trim()) {
    const q = promoSearch.value.trim().toLowerCase()
    list = list.filter(
      p =>
        p.code?.toLowerCase().includes(q) ||
        p.campaign_name?.toLowerCase().includes(q)
    )
  }
  return list
})

const loadPromoData = async () => {
  await mainGolfStore.fetchPromoCodes()
  const stats = await mainGolfStore.fetchPromoCodeStats()
  if (stats) {
    promoStats.value = stats
  }
}

const resetPromoForm = () => {
  Object.assign(promoForm, {
    id: undefined,
    code: '',
    campaign_name: '',
    type: 'percent',
    discount_value: 10,
    min_amount: undefined,
    max_discount: undefined,
    usage_limit: undefined,
    budget: undefined,
    new_users_only: false,
    valid_from: undefined,
    valid_until: undefined,
    status: 'active',
    allowed_modules: ['golf'],
    applicable_tariff_ids: [],
    description: '',
  })
}

const openPromoDialog = () => {
  resetPromoForm()
  generateRandom12Code()
  promoDialogVisible.value = true
}

const openBulkDialog = () => {
  Object.assign(bulkForm, {
    count: 10,
    prefix: 'GOLF',
    campaign_name: '',
    type: 'percent',
    discount_value: 10,
    max_discount: undefined,
    usage_limit: 1,
    valid_from: undefined,
    valid_until: undefined,
  })
  bulkDialogVisible.value = true
}

const editPromoCode = (promo: GolfPromoCode) => {
  const currentType =
    promo.type || (promo.discount_type === 'percentage' ? 'percent' : 'fixed')
  Object.assign(promoForm, {
    id: promo.id,
    code: promo.code,
    campaign_name: promo.campaign_name || '',
    type: currentType,
    discount_value: Number(promo.discount_value) || 0,
    min_amount:
      promo.min_amount !== undefined ? Number(promo.min_amount) : undefined,
    max_discount:
      promo.max_discount !== undefined ? Number(promo.max_discount) : undefined,
    usage_limit: promo.usage_limit,
    budget: promo.budget !== undefined ? Number(promo.budget) : undefined,
    new_users_only: !!promo.new_users_only,
    valid_from: promo.valid_from,
    valid_until: promo.valid_until,
    status: getDisplayStatus(promo) as any,
    allowed_modules: promo.allowed_modules || ['golf'],
    applicable_tariff_ids: Array.isArray(promo.applicable_tariff_ids)
      ? promo.applicable_tariff_ids
      : [],
    description: promo.description || '',
  })
  promoDialogVisible.value = true
}

const savePromoCode = async () => {
  try {
    const formattedCode = (promoForm.code || '').trim().toUpperCase()
    if (!promoForm.id && formattedCode.length !== 12) {
      ElMessage.error('Promo code must be exactly 12 characters')
      return
    }

    const payload: CreateGolfPromoCodePayload | UpdateGolfPromoCodePayload = {
      code: formattedCode,
      campaign_name: promoForm.campaign_name,
      type: promoForm.type,
      discount_value: promoForm.discount_value,
      min_amount: promoForm.min_amount,
      max_discount: promoForm.max_discount,
      usage_limit: promoForm.usage_limit,
      budget: promoForm.budget,
      new_users_only: promoForm.new_users_only,
      valid_from: promoForm.valid_from,
      valid_until: promoForm.valid_until,
      status: promoForm.status,
      allowed_modules: promoForm.allowed_modules,
      applicable_tariff_ids: promoForm.applicable_tariff_ids,
      description: promoForm.description,
    }

    if (promoForm.id) {
      await mainGolfStore.updatePromoCode(promoForm.id, payload)
    } else {
      await mainGolfStore.createPromoCode(payload as CreateGolfPromoCodePayload)
    }
    promoDialogVisible.value = false
    await loadPromoData()
  } catch (e: any) {
    ElMessage.error(e?.message || 'Failed to save promo code')
  }
}

const submitBulkGenerate = async () => {
  try {
    const payload: BulkCreateGolfPromoCodePayload = {
      count: bulkForm.count,
      prefix: (bulkForm.prefix || '').trim().toUpperCase(),
      campaign_name: bulkForm.campaign_name,
      type: bulkForm.type,
      discount_value: bulkForm.discount_value,
      max_discount: bulkForm.max_discount,
      usage_limit: bulkForm.usage_limit,
      valid_from: bulkForm.valid_from,
      valid_until: bulkForm.valid_until,
      allowed_modules: ['golf'],
    }
    await mainGolfStore.bulkCreatePromoCodes(payload)
    bulkDialogVisible.value = false
    await loadPromoData()
  } catch (e: any) {
    ElMessage.error(e?.message || 'Failed to bulk generate promo codes')
  }
}

const pauseCampaign = async (promo: GolfPromoCode) => {
  await mainGolfStore.pausePromoCode(promo.id)
  await loadPromoData()
}

const resumeCampaign = async (promo: GolfPromoCode) => {
  await mainGolfStore.resumePromoCode(promo.id)
  await loadPromoData()
}

const stopCampaign = async (promo: GolfPromoCode) => {
  try {
    await ElMessageBox.confirm(
      `Are you sure you want to stop promo code "${promo.code}"? It cannot be redeemed anymore.`,
      'Stop Promo Campaign',
      { type: 'warning' }
    )
    await mainGolfStore.stopPromoCode(promo.id)
    await loadPromoData()
  } catch (e: any) {
    if (e !== 'cancel') {
      ElMessage.error(e?.message || 'Failed to stop promo code')
    }
  }
}

// ============ LIFECYCLE ============
onMounted(async () => {
  headerStore.setHeaderInfo('golf.promo.title', false)
  if (!vehiclesStore.profileTariffs.length) vehiclesStore.fetchTariffs()
  await loadPromoData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('golf.promo.title')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('golf.promo.subtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "export-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(mainGolfStore).exportPromoCodesCsv()))
        }, [
          _cache[27] || (_cache[27] = _createElementVNode("img", {
            src: "/icons_golf_module/Financial Reports & Billing.svg",
            alt: "Export",
            style: {"width":"16px","height":"16px"}
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.promo.export_csv')), 1)
        ]),
        _createElementVNode("button", {
          class: "bulk-btn",
          onClick: openBulkDialog
        }, [
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "bolt-icon" }, "⚡", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.promo.bulk_generate')), 1)
        ]),
        _createElementVNode("button", {
          class: "add-promo-btn",
          onClick: openPromoDialog
        }, " + " + _toDisplayString(_ctx.$t('golf.promo.create_promo_code')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('golf.promo.total_campaigns')), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('golf.promo.all_campaigns')), 1)
          ]),
          _createElementVNode("span", _hoisted_13, _toDisplayString(promoStats.value?.totalCampaigns ?? _unref(mainGolfStore).safePromoCodes.length), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('golf.promo.active_campaigns')), 1),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('golf.promo.currently_redeemable')), 1)
          ]),
          _createElementVNode("span", _hoisted_19, _toDisplayString(promoStats.value?.activeCampaigns ?? activeCount.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('golf.promo.total_usages')), 1),
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('golf.promo.completed_redemptions')), 1)
          ]),
          _createElementVNode("span", _hoisted_25, _toDisplayString(promoStats.value?.totalRedemptions ?? totalRedemptionsCount.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('golf.promo.spent_budget')), 1),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('golf.promo.total_cumulative_discount')), 1)
          ]),
          _createElementVNode("span", _hoisted_31, " ₼" + _toDisplayString((promoStats.value?.totalSpentBudget ?? totalSpentAmount.value).toFixed(2)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, [
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "stat-dot dot-orange" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.promo.total_active_label')) + " ", 1),
            _createElementVNode("span", _hoisted_36, _toDisplayString(activeCount.value), 1)
          ]),
          _createElementVNode("span", _hoisted_37, [
            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "stat-dot dot-blue" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.promo.total_redemptions_label')) + " ", 1),
            _createElementVNode("span", _hoisted_38, _toDisplayString(totalRedemptionsCount.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[31] || (_cache[31] = _createElementVNode("img", {
              src: "/icons_golf_module/Search icon.svg",
              alt: "Search",
              style: {"width":"16px","height":"16px"}
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((promoSearch).value = $event)),
              placeholder: _ctx.$t('golf.promo.search_placeholder')
            }, null, 8, _hoisted_41), [
              [_vModelText, promoSearch.value]
            ])
          ]),
          _createVNode(_component_el_select, {
            modelValue: promoStatusFilter.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((promoStatusFilter).value = $event)),
            placeholder: _ctx.$t('golf.promo.all_statuses'),
            clearable: "",
            class: "golf-status-select",
            style: {"width":"160px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('golf.promo.all_statuses'),
                value: ""
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('golf.promo.active'),
                value: "active"
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('golf.promo.paused'),
                value: "paused"
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('golf.common.draft'),
                value: "draft"
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('golf.promo.status_expired'),
                value: "expired"
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('golf.promo.status_stopped'),
                value: "stopped"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: filteredPromoCodes.value,
          style: {"width":"100%"},
          class: "golf-data-table",
          "empty-text": _ctx.$t('golf.promo.no_promo_codes_found')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.promo.col_code_campaign'),
              "min-width": "210"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(row.code), 1),
                    _createElementVNode("button", {
                      class: "copy-btn",
                      onClick: ($event: any) => (copyToClipboard(row.code)),
                      title: _ctx.$t('golf.promo.copy_code')
                    }, _cache[32] || (_cache[32] = [
                      _createElementVNode("img", {
                        src: "/icons_golf_module/Edite.svg",
                        alt: "Copy",
                        style: {"width":"14px","height":"14px"}
                      }, null, -1)
                    ]), 8, _hoisted_46)
                  ]),
                  (row.campaign_name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(row.campaign_name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.promo.col_discount'),
              "min-width": "130"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, [
                    (
                      row.type === 'percent' ||
                        row.discount_type === 'percentage'
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(row.discount_value) + "% ", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" ₼" + _toDisplayString(row.discount_value), 1)
                        ], 64))
                  ]),
                  (row.max_discount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('golf.promo.max_prefix')) + " ₼" + _toDisplayString(row.max_discount), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.promo.col_usages_budget'),
              "min-width": "170"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("span", null, [
                      _cache[33] || (_cache[33] = _createTextVNode("Uses: ")),
                      _createElementVNode("strong", null, _toDisplayString(row.used_count || 0), 1)
                    ]),
                    (row.usage_limit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, " / " + _toDisplayString(row.usage_limit), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (row.usage_limit)
                    ? (_openBlock(), _createBlock(_component_el_progress, {
                        key: 0,
                        percentage: 
                    Math.min(
                      100,
                      Math.round(
                        ((row.used_count || 0) / row.usage_limit) * 100
                      )
                    )
                  ,
                        "stroke-width": 5,
                        "show-text": false,
                        color: 
                    row.used_count >= row.usage_limit ? '#ef4444' : '#00b074'
                  ,
                        class: "golf-progress"
                      }, null, 8, ["percentage", "color"]))
                    : _createCommentVNode("", true),
                  (row.budget)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('golf.promo.budget_prefix')) + " ₼" + _toDisplayString(row.spent_budget || 0) + " / ₼" + _toDisplayString(row.budget), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.promo.col_conditions'),
              "min-width": "150"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_55, [
                  (row.min_amount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.$t('golf.promo.min_prefix')) + " ₼" + _toDisplayString(row.min_amount), 1))
                    : _createCommentVNode("", true),
                  (row.new_users_only)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$t('golf.promo.new_users_only')), 1))
                    : _createCommentVNode("", true),
                  (!row.min_amount && !row.new_users_only)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, "—"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.promo.col_validity'),
              "min-width": "170"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_59, [
                  (row.valid_from || row.valid_until)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(formatDate(row.valid_from)) + " — " + _toDisplayString(formatDate(row.valid_until)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t('golf.promo.always_active')), 1))
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.fleet.status'),
              "min-width": "130"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["status-badge", getStatusBadgeClass(row)])
                }, [
                  _cache[34] || (_cache[34] = _createElementVNode("span", { class: "dot" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(getDisplayStatus(row)), 1)
                ], 2)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('golf.fleet.actions'),
              "min-width": "180",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("button", {
                    class: "action-btn action-edit-btn",
                    onClick: ($event: any) => (editPromoCode(row)),
                    title: _ctx.$t('golf.common.edit')
                  }, _cache[35] || (_cache[35] = [
                    _createElementVNode("img", {
                      src: "/icons_golf_module/Fleet_edit icon.svg",
                      alt: "Edit",
                      style: {"width":"18px","height":"18px"}
                    }, null, -1)
                  ]), 8, _hoisted_63),
                  (getDisplayStatus(row) === 'active')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "action-btn action-pause-btn",
                        onClick: ($event: any) => (pauseCampaign(row))
                      }, _toDisplayString(_ctx.$t('golf.promo.action_pause')), 9, _hoisted_64))
                    : _createCommentVNode("", true),
                  (getDisplayStatus(row) === 'paused')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "action-btn action-resume-btn",
                        onClick: ($event: any) => (resumeCampaign(row))
                      }, _toDisplayString(_ctx.$t('golf.promo.action_resume')), 9, _hoisted_65))
                    : _createCommentVNode("", true),
                  (getDisplayStatus(row) !== 'stopped')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "action-btn action-stop-btn",
                        onClick: ($event: any) => (stopCampaign(row))
                      }, _toDisplayString(_ctx.$t('golf.promo.action_stop')), 9, _hoisted_66))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "empty-text"])), [
          [_directive_loading, _unref(mainGolfStore).isLoading]
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: promoDialogVisible.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((promoDialogVisible).value = $event)),
      title: (promoForm as any).id ? _ctx.$t('golf.common.edit') : _ctx.$t('golf.promo.dialog_create_campaign'),
      width: "640px",
      "custom-class": "golf-dialog",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("button", {
            class: "dialog-cancel-btn",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (promoDialogVisible.value = false))
          }, " Cancel "),
          _createElementVNode("button", {
            class: "dialog-submit-btn",
            onClick: savePromoCode,
            disabled: _unref(mainGolfStore).isLoading
          }, _toDisplayString((promoForm as any).id ? _ctx.$t('golf.common.save_changes') : _ctx.$t('golf.promo.btn_create_campaign')), 9, _hoisted_88)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.campaign_name')), 1),
            _createVNode(_component_el_input, {
              modelValue: promoForm.campaign_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((promoForm.campaign_name) = $event)),
              placeholder: _ctx.$t('golf.promo.eg_campaign_name'),
              class: "golf-input"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.label_code_12_chars')), 1),
            _createElementVNode("div", _hoisted_70, [
              _createVNode(_component_el_input, {
                modelValue: promoForm.code,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((promoForm.code) = $event)),
                placeholder: _ctx.$t('golf.promo.placeholder_12_chars'),
                maxlength: "12",
                class: "golf-input code-font",
                disabled: !!(promoForm as any).id
              }, null, 8, ["modelValue", "placeholder", "disabled"]),
              (!(promoForm as any).id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "auto-generate-btn",
                    onClick: generateRandom12Code,
                    type: "button"
                  }, " 🎲 " + _toDisplayString(_ctx.$t('golf.promo.btn_auto_generate')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t('golf.promo.must_be_12_chars')), 1)
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.discount_type')), 1),
              _createVNode(_component_el_select, {
                modelValue: promoForm.type,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((promoForm.type) = $event)),
                class: "golf-select",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('golf.promo.percentage'),
                    value: "percent"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('golf.promo.fixed_amount'),
                    value: "fixed"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('golf.promo.wallet_credit'),
                    value: "wallet_credit"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.discount_value')), 1),
              _createVNode(_component_el_input_number, {
                modelValue: promoForm.discount_value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((promoForm.discount_value) = $event)),
                min: 0,
                max: promoForm.type === 'percent' ? 100 : undefined,
                precision: promoForm.type === 'percent' ? 0 : 2,
                class: "golf-input-number",
                style: {"width":"100%"}
              }, null, 8, ["modelValue", "max", "precision"])
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            (promoForm.type === 'percent')
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.label_max_discount_cap')), 1),
                  _createVNode(_component_el_input_number, {
                    modelValue: promoForm.max_discount,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((promoForm.max_discount) = $event)),
                    min: 0,
                    precision: 2,
                    placeholder: _ctx.$t('golf.promo.placeholder_optional_cap'),
                    class: "golf-input-number",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.label_min_order')), 1),
              _createVNode(_component_el_input_number, {
                modelValue: promoForm.min_amount,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((promoForm.min_amount) = $event)),
                min: 0,
                precision: 2,
                placeholder: _ctx.$t('golf.promo.placeholder_optional_min'),
                class: "golf-input-number",
                style: {"width":"100%"}
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.label_usage_limit_total')), 1),
              _createVNode(_component_el_input_number, {
                modelValue: promoForm.usage_limit,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((promoForm.usage_limit) = $event)),
                min: 1,
                placeholder: _ctx.$t('golf.promo.placeholder_unlimited'),
                class: "golf-input-number",
                style: {"width":"100%"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.budget_limit')), 1),
              _createVNode(_component_el_input_number, {
                modelValue: promoForm.budget,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((promoForm.budget) = $event)),
                min: 1,
                precision: 2,
                placeholder: _ctx.$t('golf.promo.placeholder_unlimited'),
                class: "golf-input-number",
                style: {"width":"100%"}
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.target_audience')), 1),
            _createElementVNode("div", _hoisted_82, [
              _createVNode(_component_el_checkbox, {
                modelValue: promoForm.new_users_only,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((promoForm.new_users_only) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('golf.promo.label_restrict_new_users')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.validity_window')), 1),
            _createElementVNode("div", _hoisted_84, [
              _createVNode(_component_el_date_picker, {
                modelValue: promoForm.valid_from,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((promoForm.valid_from) = $event)),
                type: "datetime",
                placeholder: _ctx.$t('golf.promo.label_valid_from'),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                class: "golf-date-picker",
                style: {"flex":"1"}
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_el_date_picker, {
                modelValue: promoForm.valid_until,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((promoForm.valid_until) = $event)),
                type: "datetime",
                placeholder: _ctx.$t('golf.promo.label_valid_until'),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                class: "golf-date-picker",
                style: {"flex":"1"}
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.label_applicable_tariffs')), 1),
            _createVNode(_component_el_select, {
              modelValue: promoForm.applicable_tariff_ids,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((promoForm.applicable_tariff_ids) = $event)),
              multiple: "",
              filterable: "",
              placeholder: _ctx.$t('golf.promo.applies_to_all_tariffs_default'),
              class: "golf-select",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tariffs.value, (tariff) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: tariff.id,
                    label: `${tariff.name} (${tariff.pricing_type})`,
                    value: tariff.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_86, [
            _cache[36] || (_cache[36] = _createElementVNode("label", null, "Status", -1)),
            _createVNode(_component_el_radio_group, {
              modelValue: promoForm.status,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((promoForm.status) = $event)),
              class: "golf-radio-group"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "active" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('golf.promo.active')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "paused" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('golf.promo.paused')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "draft" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('golf.common.draft')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: bulkDialogVisible.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((bulkDialogVisible).value = $event)),
      title: `⚡ ${_ctx.$t('golf.promo.bulk_generate_title')}`,
      width: "600px",
      "custom-class": "golf-dialog",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("button", {
            class: "dialog-cancel-btn",
            onClick: _cache[25] || (_cache[25] = ($event: any) => (bulkDialogVisible.value = false))
          }, " Cancel "),
          _createElementVNode("button", {
            class: "dialog-submit-btn",
            onClick: submitBulkGenerate,
            disabled: _unref(mainGolfStore).isLoading
          }, " Generate " + _toDisplayString(bulkForm.count) + " Codes ", 9, _hoisted_100)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.common.quantity')), 1),
              _createVNode(_component_el_input_number, {
                modelValue: bulkForm.count,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((bulkForm.count) = $event)),
                min: 1,
                max: 1000,
                class: "golf-input-number",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.prefix_max6')), 1),
              _createVNode(_component_el_input, {
                modelValue: bulkForm.prefix,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((bulkForm.prefix) = $event)),
                maxlength: "6",
                placeholder: "e.g. GOLF",
                class: "golf-input code-font"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.campaign_name')), 1),
            _createVNode(_component_el_input, {
              modelValue: bulkForm.campaign_name,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((bulkForm.campaign_name) = $event)),
              placeholder: "e.g. VIP Golf Tournament 2026",
              class: "golf-input"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.discount_type')), 1),
              _createVNode(_component_el_select, {
                modelValue: bulkForm.type,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((bulkForm.type) = $event)),
                class: "golf-select",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('golf.promo.percentage'),
                    value: "percent"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('golf.promo.fixed_amount'),
                    value: "fixed"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.discount_value')), 1),
              _createVNode(_component_el_input_number, {
                modelValue: bulkForm.discount_value,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((bulkForm.discount_value) = $event)),
                min: 0,
                max: bulkForm.type === 'percent' ? 100 : undefined,
                class: "golf-input-number",
                style: {"width":"100%"}
              }, null, 8, ["modelValue", "max"])
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('golf.promo.validity_window')), 1),
            _createElementVNode("div", _hoisted_98, [
              _createVNode(_component_el_date_picker, {
                modelValue: bulkForm.valid_from,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((bulkForm.valid_from) = $event)),
                type: "datetime",
                placeholder: _ctx.$t('golf.promo.label_valid_from'),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                class: "golf-date-picker",
                style: {"flex":"1"}
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_el_date_picker, {
                modelValue: bulkForm.valid_until,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((bulkForm.valid_until) = $event)),
                type: "datetime",
                placeholder: _ctx.$t('golf.promo.label_valid_until'),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                class: "golf-date-picker",
                style: {"flex":"1"}
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})